import axios from 'axios';

const baseURL = process.env.REACT_APP_TIAO_URL;

export const getHtml = async component => {
  return axios.request({ baseURL, url: component, method: 'GET' });
};
